import { render, staticRenderFns } from "./setTemplateDialog.vue?vue&type=template&id=64aa5c29&scoped=true&"
import script from "./setTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./setTemplateDialog.vue?vue&type=script&lang=js&"
import style0 from "./setTemplateDialog.vue?vue&type=style&index=0&id=64aa5c29&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aa5c29",
  null
  
)

export default component.exports